/* eslint-disable */
export interface SpoilerData {
  /** Spoiler ID. */
  id?: string;
}

const baseSpoilerData: object = {};

export const SpoilerData = {
  fromJSON(object: any): SpoilerData {
    const message = { ...baseSpoilerData } as SpoilerData;
    message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
    return message;
  },

  toJSON(message: SpoilerData): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },
};
